.headerContainer {
  background: var(--color-header-background);
  color: var(--color-primary-text);
}

.headerInnerContainer {
  max-width: var(--page-max-width);
  min-height: 4.75rem;
  margin: 0 auto;
  padding-inline: var(--header-footer-padding-x);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.siteTitle {
  margin: 0;
  font-family: var(--font-family-header);
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.02em;
}

.iconContainer {
  display: flex;
  align-items: center;
  gap: var(--space-6);
}

.logos {
  display: flex;
  align-items: center;
  gap: var(--space-6);
}

.headerDivider {
  width: 2px;
  height: 40px;
  flex-shrink: 0;

  background: rgba(255, 255, 255, 0.651);
}

.logoutButton {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);

  border: 0;
  background: none;
  color: var(--color-primary-text);

  font: inherit;
  font-weight: var(--font-weight-semibold);

  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.16s ease, transform 0.08s ease;
}

.logoutButton svg {
  font-size: 1.125rem;
  transition: transform 0.16s ease;
}

.logoutButton:hover,
.logoutButton:focus-visible {
  opacity: 1;
}

.logoutButton:hover::after,
.logoutButton:focus-visible::after {
  transform: scaleX(1);
}

.logoutButton:hover svg {
  transform: translateX(2px);
}

.logoutButton:focus-visible {
  outline: 3px solid var(--color-focus-ring);
  outline-offset: 2px;
}

.csufLogo,
.nsfLogo {
  height: 40px;
  width: auto;
}

.nsfLogo {
  height: 50px;
}
